import { render, staticRenderFns } from "./LayoutContent.vue?vue&type=template&id=52b1426f&scoped=true"
import script from "./LayoutContent.vue?vue&type=script&lang=js"
export * from "./LayoutContent.vue?vue&type=script&lang=js"
import style0 from "./LayoutContent.vue?vue&type=style&index=0&id=52b1426f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b1426f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/_work/studio-admin/studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b1426f')) {
      api.createRecord('52b1426f', component.options)
    } else {
      api.reload('52b1426f', component.options)
    }
    module.hot.accept("./LayoutContent.vue?vue&type=template&id=52b1426f&scoped=true", function () {
      api.rerender('52b1426f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LayoutContent.vue"
export default component.exports